import { UiGuideChapterModel } from "../../models";

import { mockRouteModel } from "./mock-route";

export function mockUiGuideChapterModel({
    id = "GuideChapter-1234",
    type = "uiGuideChapter",
    locale = "en",
    content = mockUiGuideChapterModelContent()
}: Partial<UiGuideChapterModel> = {}): UiGuideChapterModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiGuideChapterModelContent = UiGuideChapterModel["content"];

export function mockUiGuideChapterModelContent({
    title = "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    route = mockRouteModel(),
    category = "",
    sections = [],
    ...optionals
}: Partial<UiGuideChapterModelContent> = {}): UiGuideChapterModelContent {
    return {
        title,
        route,
        category,
        sections,
        ...optionals
    };
}
